export function parseMoney(value) {
  if (value === null || value === undefined) return 0;
  const raw = String(value).trim();
  // Preserve a single leading minus so discount line items can be entered
  // as negative values (e.g. "-50"). Strip everything else non-numeric.
  const isNegative = raw.startsWith("-");
  const cleaned = raw.replace(/[^0-9.]/g, "");
  const n = parseFloat(cleaned) || 0;
  return isNegative ? -n : n;
}

export function formatMoneyDisplay(value) {
  const amount = parseMoney(value);
  if (amount < 0) return `-$${(-amount).toFixed(2)}`;
  return `$${amount.toFixed(2)}`;
}

export function formatMoneyInput(value) {
  const amount = parseMoney(value);
  if (!amount) return "";
  return String(amount);
}
